const initialState = {
  loading: false,
  allHeuristic: [],
  selectedHeuristic: null,
};

const heuristicReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case "LOADING_HEURISTIC": {
      return {
        ...state,
        loading: actions.loading,
      };
    }
    case "GET_HEURISTIC_DATA": {
      return {
        ...state,
        loading: actions.loading,
        allHeuristic: actions.data,
      };
    }
    //   case "UPDATE_EVENT": {
    //     return { ...state, events: actions.data };
    //   }
    //   case "GET_EVENT_GROUPS": {
    //     return { ...state, eventGroup: actions.data };
    //   }
    //   case "SET_SELECTED_EVENT": {
    //     return { ...state, selectedEvent: actions.data };
    //   }
    //   case "CLEAR_EVENT": {
    //     return { ...state, selectedEvent: [] };
    //   }
    default:
      return state;
  }
};
export default heuristicReducer;
